import { injectable } from "tsyringe";

@injectable()
export class BeaconGenerator {
  generate(): string {
    // for users from GDPR countries if they did not give consent for tracking
    // we assign random values to session cookies; should match results of:
    // https://developer.fastly.com/reference/vcl/functions/randomness/randomstr/
    const validCharacters =
      "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz_-";

    let resultValue = "";

    while (resultValue.length < 10) {
      resultValue +=
        validCharacters[(Math.random() * validCharacters.length) | 0];
    }

    return resultValue;
  }
}
